/**
 * 定义事件名称的枚举
 */

export const PAGE_DATA = 'PAGE_DATA' // 页面传递数据的事件

export const SUBMIT_DATA = 'SUBMIT_DATA' // 提交数据的操作
export const SEARCH_DATA = 'SEARCH_DATA' // 查询数据的操作
export const REFRESH_SEARCH_DATA = 'REFRESH_SEARCH_DATA' // 重新查询的数据
export const INIT_SEARCH_PARAMS = 'INIT_SEARCH_PARAMS' // 初始化查询参数

// 询问有多少要提交数据的容器组件
export const ASK_SUBMIT_NUMBER = 'ASK_SUBMIT_NUMBER'
// 回答有多少要提交数据的容器组件
export const ANSWER_SUBMIT_NUMBER = 'ANSWER_SUBMIT_NUMBER'

// 叫要提交数据的容器组件，将数据发过来
export const GIVE_ME_SUBMIT_DATA = 'GIVE_ME_SUBMIT_DATA'
// 给提交组件，要提交的数据
export const HERE_YOU_SUBMIT_DATA = 'HERE_YOU_SUBMIT_DATA'
// 给操作按钮，要列表选中项的数据
export const BATCH_HANDLE_DATA = 'BATCH_HANDLE_DATA'


// WEBPACK FOOTER //
// ./src/utils/events.js